import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

/**
 * A small in-app confirmation dialog built on the shared Modal — the polished replacement for
 * `window.confirm`. Cancel dismisses; the confirm button runs `onConfirm` (danger-styled for
 * destructive actions). `busy` shows a spinner + blocks both actions while the work runs.
 */
export function ConfirmModal({
  open,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  busy = false,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title?: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={busy}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="text-sm text-ink-label">{message}</div>
    </Modal>
  );
}
